import { SingleDatepicker, type SingleDatepickerProps } from '@piccolohealth/ui';
import { DateTime } from '@piccolohealth/util';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends Omit<SingleDatepickerProps, 'onChange' | 'value'> {
  name: string;
}

export const HookedSingleDatepicker = (props: Props) => {
  const { name, ...rest } = props;
  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  const onChange = (date: DateTime | null) => {
    inputProps.onChange(date ? date.toISO() : null);
  };

  return (
    <SingleDatepicker
      {...rest}
      onChange={onChange}
      value={inputProps.value ? DateTime.fromISO(inputProps.value) : null}
    />
  );
};
